import Type1 from "./option";

export default Type1;
